module.exports = __webpack_public_path__ + "img/welcome_7.339fe0f5.jpg";